import { ajax } from '../ajax'


//、 授课-课中互评列表
export const reqSKCommentList = (paramets) => ajax(`/jxclassroom/jxClassroomMutualEvaluation/list`, paramets)

//、 教学预习互评-通过id查询详情
export const reqSKCommentDetails = (paramets) => ajax(`/jxclassroom/jxClassroomMutualEvaluationStu/list`, paramets)

//、 授课-课中互评添加
export const reqSKCommentAdd = (paramets) => ajax(`/jxclassroom/jxClassroomMutualEvaluation/add`, paramets, 'post')

//、 授课-课中互评编辑
export const reqSKCommentEdit = (paramets) => ajax(`/jxclassroom/jxClassroomMutualEvaluation/edit`, paramets, 'put')

